export const ENTITY_TO_BUNDLE_NAME = {
  'device': 'Devices'
}
